module.exports = __webpack_public_path__ + "fonts/baronsans-light-webfont.edfc1c24.woff";